import script from "./checkRulesDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./checkRulesDialog.vue?vue&type=script&setup=true&lang=js"

import "./checkRulesDialog.vue?vue&type=style&index=0&id=04df716f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04df716f"]])

export default __exports__